import { FormlyFieldConfig } from "@ngx-formly/core";

export const AllegatiNullaOstaStep: FormlyFieldConfig[] =[
    {
      "props": { "label": 'ALLEGATI ' },
      "fieldGroup": [
        {
          "key": 'allegato_ci',
          "type": 'mat-upload',
          "props": {
            "label": "DOCUMENTO DI IDENTITÀ",
            "multiple": true,
            "required":true
          },
        },
        {

          "key": 'allegati_altra_documentazione',
          "type": 'mat-upload',
          "props": {
            "label": "ALTRA DOCUMENTAZIONE",
            "multiple": true,
          },
        }
      ]
    },
  ]

